import MTooltipBasic from "./MTooltipBasic.vue";
export default MTooltipBasic;
export type { MTooltipBasicProps } from "./MTooltipBasic.props";
